import { ReactElement, ReactNode } from 'react'

export const getNodeText = (node: ReactNode): string | number | undefined => {
  if (['string', 'number'].includes(typeof node)) return node as string | number
  if (node instanceof Array) return node.map(getNodeText).join('')
  if (typeof node === 'object' && node) return getNodeText((node as ReactElement).props.children)
  return undefined
}